import { Outlet } from 'react-router-dom';
import { TopBar } from './components/TopBar';
import { Toaster } from './components/Toaster';

export function App() {
  return (
    <div className="flex h-full min-h-screen flex-col bg-canvas text-text-1">
      <TopBar />
      <div className="flex-1 overflow-hidden">
        <Outlet />
      </div>
      <Toaster />
    </div>
  );
}
